var jQuery=$=require('jquery');
    window.jQuery=jQuery;
    require('bootpag');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
                country:'',
                searchText:'',
                searchlist:'',
                distance:'',
                id:this.$route.params.id,
                param:this.$route.params.id,
                url : this.baseApiPath,
                show_country:false,
                addCountry:'国家',
                addCity:'城市',
                countryname:'',
                en:'',
                latlng:'',
                countryid:'',
                countrylist:{},
                citylist:{},
                cityid:'',
                show_city:false,
                cityname:'',
                city: '',
                hotelId: '',
                addname:'',
                adden:'',
                name: '',
                en: '',
                user:'',
                brand: '',
                type:0,
                newtype:0,
                typekey:0,
                star: 0,
                limit: 20,
                page: 1,
                total: 0,
                list: [],
                rows:0
            }
        },
        // compiled:function(){
        //     console.log('compiled')
        // },
        created:function(){
       
        },
        ready:function(){
            //console.log('readyready')
            var that=this;
            this.search({hotel_id:this.id},0);
            this.param=this.id=this.$route.params.id;
            $('#callBackPager').bootpag({
               total: this.total,
                page:1,
                maxVisible: 10
                }).on("page", function(event, /* page number here */ num){
                    // console.log(1)
                that.search({hotel_id:this.id,page:num},1)
              });
            var jqPromise = $.post(this.url, {
                method: 'district_country',
                token: localStorage['token']
            });
            var realPromise = Promise.resolve(jqPromise),
            that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.countrylist = val.data;
            });
            this.$watch('countryid', function(val) {
                // this.search(val);
                if(typeof val !== "string"){
                    val=val[0]
                }
                var promise = $.post(this.url, {
                method: 'district_city',
                token: localStorage['token'],
                country:val
            });
            var realPromise = Promise.resolve(promise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.citylist = val.data;
            });
            })
        },
        methods:{
             unBindAround:function(id){
                console.log(id)
                  var data={
                    method:'hotel_around_unbind',
                    hotel_id: this.id,
                    id:id,
                    token:localStorage['token'],
                }
                  this.$http.post(this.url,data,{emulateJSON:true})
                    .then(function(value){
                    if (value.data.code==0) {
                        alert('解绑成功')
                    }else{
                        alert(value.data.message)
                    }
                    return value
                 })
                .then(function(value){
                    this.search({hotel_id:this.id},0);
                })
            },
            bindAround:function(){
                    var list=$('input:checked'),listValue=[];
                    for (var i = list.length - 1; i >= 0; i--) {
                        listValue.push(list[i].value)
                    }
                var data = {
                    method: 'hotel_around_bind',
                    token: localStorage.token,
                     hotel_id: this.id,
                     around_ids:listValue,
                    limit: 20,
                    page: 1
                }
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise);
                var that = this,rebuild=rebuild;
                realPromise.then(function(res) {
                    var res = JSON.parse(res)
                    if (res.code == 0&&res.data==true) {
                        alert('添加成功')
                    } else {
                        alert(res['message'])
                    }
                    return res;
                })
                .then(function(){
                    that.search({hotel_id:that.id},0);
                })
            },
            getList:function(){
                var allHotelData = {
                    method: 'around_search',
                    token: localStorage.token,
                    hotel_id:this.id,
                     keywords: this.searchText,
                     distance:this.distance,
                    limit: 20,
                    page: 1
                }
                var jqPromise = $.post(this.url, allHotelData);
                var realPromise = Promise.resolve(jqPromise);
                var that = this,rebuild=rebuild;
                realPromise.then(function(res) {
                    var res = JSON.parse(res)
                    if (res.code == 0) {
                        that.searchlist = res.data['list'];
                    } else {
                        alert(res['message'])
                    }
                    return res;
                })
            },
            addAround:function(){
                var data={
                    method:'around_create',
                    type:this.id,
                    name:this.addname,
                    en:this.adden,
                    token:localStorage['token'],
                    type:this.newtype,
                    country:this.countryid,
                    city:this.cityid,
                    lat:this.latlng.split(',')[1],
                    lng:this.latlng.split(',')[0]
                }
                this.$http.post(this.url,data,{emulateJSON:true})
                    .then(function(value){
                       if (value.data.code==0) {
                         alert('添加成功')
                         this.getList();
                       }
                    
                    return value
                 });
            },
            choicecountry:function(item){
                this.addCountry=item.name;
                this.countryid=item.id
                this.show_country=false
                this.city='';
                this.cityname='';
            },
              choicecity:function(item){
                this.addCity=item.name;
                this.cityid=item.id;
                this.show_city=false
                this.district='';
                this.districtname='';
            },
            showCountry:function(){
                this.show_city=false;
                this.show_country==true?this.show_country=false:this.show_country=true;
                
            },
            showCity:function(){
                this.show_country=false;
                this.show_city==true?this.show_city=false:this.show_city=true;
            },
           search:function(val,rebuild){
                var url = this.baseApiPath;
                var allHotelData = {
                    method: 'hotel_around_list',
                    token: localStorage.token,
                    hotel_id:val&&val.hotel_id,
                    limit: val&&val.limit||this.limit || 20,
                    page: val&&val.page||this.page|| 1
                }
                var jqPromise = $.post(url, allHotelData);
                var realPromise = Promise.resolve(jqPromise);
                var that = this,rebuild=rebuild;
                realPromise.then(function(res) {
                    var res = JSON.parse(res)
                    if (res.code == 0) {
                        that.list = res.data['list'];
                        that.rows = res.data.page.rows;
                        that.total = res.data.page.total
                    } else {
                        alert(res['message'])
                    }
                    return res;
                })
                .then(function(res) {
                    if(!rebuild){
                          $('#callBackPager').bootpag({
                            total: that.total,
                            page:1,
                            maxVisible: 10
                        }).on("page", function(event, num){
                             that.search({hotel_id:that.id,page:num},1)
                        });
                    }
                    return res;
                })
            }
        },
        route:{
            activate:function(transtition){
                transtition.next()
            },
            data:function(transtition){
                this.search({hotel_id:this.id},0);

                 this.$dispatch('pageinfo','');
                transtition.next();
            }
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/hotelAround.vue
// module id = 96
// module chunks = 0